import React, { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Link, useNavigate } from "react-router-dom";
import { axiosTokenInstance } from "../../axiosConfig/axios";
import calendarImg from "../../assets/images/calendar.svg";
import "./order.css";
import OrderDetails from "./order-details";
import OrderStatus from "./order-status";
import Loading from "../../components/loading/loading";
import { Loader2, SaudiRiyal } from "lucide-react";
import dollar from "../../assets/images/product-details/dollar-square.svg";
import SplitOrder from "../Payment/split-order";
import WaysOfPayment from "../Payment/ways-of-payment";
import ticketDiscount from "../../assets/images/ticket-discount.svg";
import { Check } from "lucide-react";

const Order = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const [orderProductDetails, setOrderProductDetails] = useState({});
  const [isOpen, setIsOpen] = useState(false);
  const [isWaysOfPaymentOpen, setIsWaysOfPaymentOpen] = useState(false);
  const [couponDetails, setCouponDetails] = useState(false);
  const [coupon, setCoupon] = useState({});
  const [code, setCode] = useState("");
  const [isApplied, setIsApplied] = useState(false);
  const [promotion_id, setPromotionID] = useState(null);
  const [isLoadingCoupon, setIsLoadingCoupon] = useState(false);

  const order_id = localStorage.getItem("order-id");
  const token = localStorage.getItem("token");

  // console.log(orderProductDetails);

  useEffect(() => {
    localStorage.removeItem("user-logged");
  }, []);

  // get order product details
  const getOrderDetails = () => {
    axiosTokenInstance
      .get(`/connector/api/users/order/${order_id}`)
      .then((res) => {
        setOrderProductDetails(res.data.data);
        setIsLoading(false);
      });
  };

  useEffect(() => {
    getOrderDetails();
  }, []);

  // console.log("orderProductDetails>>>>>>>>>>>>>>>>", orderProductDetails);

  const formatDate = (dateString) => {
    const date = new Date(dateString);

    // Format date and time in 12-hour format with "AM/PM"
    const formattedDate = date
      .toLocaleString("en-GB", {
        timeZone: "UTC",
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        hour12: true, // Use 12-hour format
      })
      .replace(",", "") // Remove any comma
      .replace(/\//g, "-"); // Replace / with -

    // Remove "AM" or "PM" from the string
    return formattedDate.replace(/AM|PM/gi, "").trim();
  };

  // Example usage
  const date = orderProductDetails?.created_at;

  const handleDownloadInvoice = async () => {
    try {
      axiosTokenInstance
        .get(`/connector/api/users/order/downloadInvoice/${order_id}`)
        .then((res) => {
          const fileUrl = res.data?.link;
          if (fileUrl) {
            const link = document.createElement("a");
            link.href = fileUrl;
            link.setAttribute("download", "invoice.pdf");
            document.body.appendChild(link);
            link.click();
            link.remove();
          } else {
            console.error("No file link in response");
          }
        });
    } catch (error) {
      console.error("Error downloading invoice:", error);
    }
  };

  const handlePayment = () => {
    if (!token) {
      localStorage.setItem("user-logged", true);
      navigate(`/login`);
    } else {
      orderProductDetails?.payment_status === "partial"
        ? setIsOpen(true)
        : setIsWaysOfPaymentOpen(true);
    }
  };

  //apply coupon
  const applyCoupon = async () => {
    setIsLoadingCoupon(true);

    try {
      const res = await axiosTokenInstance.post(
        "/connector/api/users/order/calculate-promotion",
        {
          order_id,
          promotion_code: code,
        },
      );

      if (res?.data.status === 200) {
        toast.success(res.data.message, {
          position: toast.POSITION.BOTTOM_RIGHT,
          autoClose: 2000,
        });
        setIsApplied(true);
        setPromotionID(res.data.data.promotion_id);
        setCoupon(res.data.data);
        setCouponDetails(true);
        setIsLoadingCoupon(false);
      } else {
        toast.error(res.data.message, {
          position: toast.POSITION.BOTTOM_RIGHT,
          autoClose: 2000,
        });
        setIsLoadingCoupon(false);
      }
    } catch (err) {
      console.log(err);

      const msg =
        err?.response?.data?.message ||
        err?.message ||
        "حدث خطأ ما حاول مرة اخري";

      toast.error(msg, {
        position: toast.POSITION.BOTTOM_RIGHT,
        autoClose: 2000,
      });
      setIsLoadingCoupon(false);
    }
  };

  return (
    <>
      {isLoading ? (
        <Loading />
      ) : (
        <div className="my-orders">
          <h2>تفاصيل الطلب</h2>
          {/* start section of order details */}
          <div className="order-details-info">
            {orderProductDetails?.info && (
              <div className="info">
                <img
                  src={orderProductDetails.info.logo}
                  alt={orderProductDetails.info.location}
                />
                <div className="content">
                  <h3>{orderProductDetails.info.location}</h3>
                  <div className="calendar">
                    <img src={calendarImg} alt="calendar" />
                    <p>{formatDate(date)}</p>
                  </div>
                </div>
              </div>
            )}

            <hr />

            {orderProductDetails?.items.length > 0 &&
              orderProductDetails?.items?.map((item) => (
                <OrderDetails key={item.id} product={item} />
              ))}
            {/* <hr /> */}
            {/* <div className="footer-price">
              <p>الاجمالي الصافي</p>
              <p className="price">
                {orderProductDetails.due} <SaudiRiyal size={13} />
              </p>
            </div> */}
          </div>
          {/* end section of order details */}

          {/* start section of order paid*/}
          <div className="payment-box">
            <img src={dollar} alt="dollar-icon" />

            <div className="payment-info">
              <div className="payment-title">
                <div>حالة الدفع</div>
                <div className="payment-status unpaid">
                  {orderProductDetails?.payment_status_display}
                </div>
              </div>

              <div className="payment-details">
                <span className="paid-text">المدفوع</span>
                <span className="paid-amount">
                  {orderProductDetails?.total_paid}
                  <SaudiRiyal size={13} />
                </span>
                <span className="remaining-text">الباقي</span>
                <span className="remaining-amount">
                  {orderProductDetails?.due}
                  <SaudiRiyal size={13} />
                </span>
              </div>
            </div>
          </div>
          {/* end section of order paid*/}

          {/* Section of Coupon */}
          {orderProductDetails.payment_status !== "paid" &&
            orderProductDetails.payment_status !== "partial" && (
              <div className="coupon">
                <img src={ticketDiscount} alt="ticket-discount" />

                <input
                  placeholder="اضف كود الخصم"
                  type="text"
                  value={code}
                  disabled={isApplied || isLoadingCoupon}
                  onChange={(e) => {
                    if (isApplied) return;
                    setCode(e.target.value);
                  }}
                />

                <Button
                  onClick={applyCoupon}
                  disabled={isLoadingCoupon || isApplied || !code?.trim()}
                  className="btn-applied"
                >
                  {isLoadingCoupon ? (
                    <Loader2 className="lucide-spin" size={18} />
                  ) : !isApplied ? (
                    "تطبيق"
                  ) : (
                    <Check />
                  )}
                </Button>
              </div>
            )}

          {/* End Section of Coupon */}

          {/* Start price details */}

          <div className="cart-price-details">
            <h6 style={{ margin: "0", fontSize: "14px" }}>تفاصيل الفاتورة</h6>
            <hr />
            {couponDetails ? (
              <div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <p
                    style={{
                      margin: "0",
                      color: "black",
                      fontSize: "14px",
                    }}
                  >
                    الإجمالي
                  </p>
                  <p style={{ margin: "0" }}>
                    {coupon.total_before_discount} <SaudiRiyal size={14} />
                  </p>
                </div>
                <hr />
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <p
                    style={{
                      margin: "0",
                      color: "black",
                      fontSize: "14px",
                    }}
                  >
                    الخصم
                  </p>
                  <p style={{ margin: "0" }}>
                    {coupon.discount} <SaudiRiyal size={14} />
                  </p>
                </div>
                <hr />
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <p
                    style={{
                      margin: "0",
                      color: "#4FAF5A",
                      fontSize: "14px",
                    }}
                  >
                    الإجمالي الصافي
                  </p>
                  <p style={{ margin: "0" }}>
                    {coupon.total_after_discount} <SaudiRiyal size={14} />
                  </p>
                </div>
              </div>
            ) : orderProductDetails.coupon_apply ? (
              <div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <p
                    style={{
                      margin: "0",
                      color: "black",
                      fontSize: "14px",
                    }}
                  >
                    الإجمالي
                  </p>
                  <p style={{ margin: "0" }}>
                    {orderProductDetails.total} <SaudiRiyal size={14} />
                  </p>
                </div>
                <hr />
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <p
                    style={{
                      margin: "0",
                      color: "black",
                      fontSize: "14px",
                    }}
                  >
                    الخصم
                  </p>
                  <p style={{ margin: "0" }}>
                    {orderProductDetails.discount} <SaudiRiyal size={14} />
                  </p>
                </div>
                <hr />
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <p
                    style={{
                      margin: "0",
                      color: "#4FAF5A",
                      fontSize: "14px",
                    }}
                  >
                    الإجمالي الصافي
                  </p>
                  <p style={{ margin: "0" }}>
                    {orderProductDetails.final_total} <SaudiRiyal size={14} />
                  </p>
                </div>
              </div>
            ) : (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",

                  fontSize: "14px",
                }}
              >
                <p
                  style={{
                    margin: "0",
                    color: "#4FAF5A",
                  }}
                >
                  الإجمالي الصافي
                </p>

                <p style={{ margin: "0" }}>
                  {" "}
                  {orderProductDetails.final_total}
                  <SaudiRiyal size={14} />
                </p>
              </div>
            )}
          </div>

          {/* End  price details */}

          {/* start section of order status*/}
          <OrderStatus
            currentStatus={orderProductDetails?.currentStatus}
            is_in_kitchen={orderProductDetails?.is_in_kitchen}
          />
          {/* end section of order status*/}

          {/* Start section buttons */}
          <div className="order-group-btns">
            {orderProductDetails?.payment_status === "paid" ? (
              <>
                {orderProductDetails?.hasReview ? (
                  <Button
                    className="payment"
                    onClick={() => handleDownloadInvoice()}
                  >
                    تحميل الفاتورة
                  </Button>
                ) : (
                  <Button
                    className="review"
                    onClick={() => navigate("/review")}
                  >
                    قيم تجربتك
                  </Button>
                )}
              </>
            ) : orderProductDetails?.payment_status === "partial" ? (
              <>
                <Button className="payment" onClick={() => handlePayment()}>
                  دفع
                </Button>
              </>
            ) : (
              <>
                <Button className="payment" onClick={() => handlePayment()}>
                  دفع
                </Button>
              </>
            )}
          </div>
          {/* End section buttons */}
          {isOpen && (
            <SplitOrder setIsOpen={setIsOpen} promotion_id={promotion_id} />
          )}
          {isWaysOfPaymentOpen && (
            <WaysOfPayment
              setIsOpen={setIsOpen}
              setIsWaysOfPaymentOpen={setIsWaysOfPaymentOpen}
              promotion_id={promotion_id}
            />
          )}
        </div>
      )}

      <ToastContainer />
    </>
  );
};

export default Order;
